<template>
    <div class="row" v-show="aMiniBanners.length > 0">
        <div class="col-12 mobile-title" :class=" !isMobile ? 'py-3' : 'pt-2 pb-3'">
            <span class="fs-30 fw-300 color-primary-n">No te lo puedes perder</span>
        </div>

        <div class="col-12">
            <div class="row">
                <div class="col-md-6 mb-2"
                     v-for="(minibanner, index) in aMiniBanners"
                     :class="[ minibanner.url ? 'cursor-pointer' : '' ]"
                     :key="'mb_' + index"
                     @click="openMiniBannerUrl(minibanner)">
                    <img class="minibanner-img img-fluid w-100"
                         :src="minibanner.path"
                         :alt="minibanner.file_name"
                         height="250px">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import fileRootPathMixin from '../../../mixins/fileRootPathMixin';

export default {

    mixins: [fileRootPathMixin],

    data() {

        return {

            aMiniBanners: [],

        };

    },

    mounted() {

        this.loadMiniBanners();

    },

    methods: {

        loadMiniBanners() {

            const miniBanners = $.parseJSON(localStorage.getItem('mini_banners'));

            if (miniBanners && miniBanners.length > 0) {

                this.aMiniBanners = miniBanners.map((minibanner) => {

                    minibanner.path = this.fileRootPath + minibanner.path;

                    return minibanner;

                });

            }

        },

        openMiniBannerUrl({ url, opening_type = '_self' }) {

            if (url) {

                window.open(url, opening_type);

            }

        },

    },

};
</script>
